import React, { useEffect, useState } from "react";
import {
  Container,
  Nav,
  Navbar,
  Form,
  FormControl,
  Button,
} from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import Footer from "./Footer";
import moment from "moment-timezone";
import Select from "react-select";

const ALLOWED_EMAILS = [
  "kunwar@embaiimu.in",
  "kunwarpratap.singh.emba2025@iimu.ac.in",
];

const Layout = ({ children }) => {
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [timezone, setTimezone] = useState("Asia/Kolkata");

  const timezones = moment.tz.names().map((tz) => ({
    value: tz,
    label: tz,
  }));

  useEffect(() => {
    const storedZone = localStorage.getItem("userTimezone");
    if (storedZone) {
      setTimezone(storedZone);
    } else {
      localStorage.setItem("userTimezone", "Asia/Kolkata");
    }
  }, []);

  const handleTimezoneChange = (selectedOption) => {
    setTimezone(selectedOption.value);
    localStorage.setItem("userTimezone", selectedOption.value);
    window.location.reload(); // reload to apply site-wide
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (search.trim()) {
      navigate(`/search?q=${encodeURIComponent(search.trim())}`);
      setSearch("");
    }
  };

  const logout = () => {
    localStorage.removeItem("loggedInUser");
    navigate("/login");
  };
  const storedUser = localStorage.getItem("loggedInUser");
  const user = storedUser ? JSON.parse(storedUser) : null;
  return (
    <>
      <Navbar bg="dark" variant="dark" expand="lg" fixed="top">
        <Container fluid>
          <Navbar.Brand as={Link} to="/" className="fw-bold">
            My LMS
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="navbar-nav" />
          <Navbar.Collapse id="navbar-nav" className="justify-content-between">
            <Nav className="me-auto">
              <Nav.Link as={Link} to="/">
                Dashboard
              </Nav.Link>
              <Nav.Link as={Link} to="/calendar">
                Calendar
              </Nav.Link>
              <Nav.Link as={Link} to="/courses">
                Courses
              </Nav.Link>
              <Nav.Link as={Link} to="/assignments">
                Assignments
              </Nav.Link>
              {/* <Nav.Link as={Link} to="/results">FRA Score</Nav.Link> */}
              {/* External links */}
              <Nav.Link
                href="https://iimu-production.azrisolutions.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Button
                  variant="outline-primary"
                  size="sm"
                  style={{
                    color: "#fff", // white text
                    fontWeight: "bold",
                    borderColor: "#007bff", // keeps the outline visible
                  }}
                >
                  Moodle
                </Button>
              </Nav.Link>

              <Nav.Link
                href="https://sisportal-100695.campusnexus.cloud/CMCPortal/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Button
                  variant="outline-success"
                  size="sm"
                  style={{
                    color: "#fff", // white text
                    fontWeight: "bold",
                    borderColor: "#28a745", // keeps the outline visible
                  }}
                >
                  SIS Portal
                </Button>
              </Nav.Link>
            </Nav>

            <Form className="d-flex me-3" onSubmit={handleSubmit}>
              <FormControl
                type="search"
                placeholder="Search"
                className="me-2"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
              <Button variant="outline-light" type="submit">
                Go
              </Button>
            </Form>

            {/* Searchable Timezone Dropdown */}
            <div style={{ width: 250 }} className="me-3">
              <Select
                options={timezones}
                value={{ value: timezone, label: timezone }}
                onChange={handleTimezoneChange}
                placeholder="Select Timezone"
                isSearchable
              />
            </div>

            <Button variant="danger" onClick={logout}>
              Logout
            </Button>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      <Container className="mt-4 content-container">{children}</Container>
      <Footer />
    </>
  );
};

export default Layout;
